import React, { useState } from 'react';
import MaterialTooltip from '@mui/material/Tooltip';
import ClickAwayListener from '@mui/material/ClickAwayListener';

import './styles.css';

export const Tooltip = ({ title, className = 'tooltipStyles', children }) => {
  const [open, setOpen] = useState(false);

  const handleTooltipToggle = () => setOpen((prev) => !prev);
  const handleTooltipClose = () => setOpen(false);

  return window.screen.width > 768 ? (
    <MaterialTooltip title={title} arrow placement="right">
      <span className={className}>{children}</span>
    </MaterialTooltip>
  ) : (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <MaterialTooltip placement="bottom" title={title} arrow open={open}>
        <button
          type="button"
          onClose={handleTooltipClose}
          onClick={handleTooltipToggle}
          className={className}
        >
          {children}
        </button>
      </MaterialTooltip>
    </ClickAwayListener>
  );
};
